(function() {
  'use strict';

  function initProductShippingPopup() {
    var popup = document.querySelector('[data-product-shipping-popup]');

    if (!popup || popup.dataset.initialized === 'true') return;

    var closeButtons = popup.querySelectorAll('[data-product-shipping-popup-close]');
    var closeButton = popup.querySelector('.product-shipping-popup__close');
    var previouslyFocused = document.activeElement;

    function closePopup() {
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('product-shipping-popup-open');

      if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
        previouslyFocused.focus();
      }
    }

    function handleKeydown(event) {
      if (event.key === 'Escape') closePopup();
    }

    closeButtons.forEach(function(button) {
      button.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', handleKeydown);
    popup.dataset.initialized = 'true';
    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('product-shipping-popup-open');

    if (closeButton) closeButton.focus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductShippingPopup);
  } else {
    initProductShippingPopup();
  }
})();